import Link from "next/link";
import { portalRoutes } from "@nju/routes";
import { A, BlockContent, BlockText, Heading, Separator, Text } from "@nju/ui";

export function CaptiveBanner() {
  return (
    <div className="bg-cerulean">
      <BlockContent overflow={{ "@onlyMobile": true, "@fromTablet": "y" }}>
        <div className="grid pt-6 pb-5 from-tablet:min-h-[600px] from-tablet:grid-cols-[1fr_0.8fr]">
          <div className="mt-20">
            <Heading
              align={{
                "@onlyMobile": "center",
              }}
              variant="h1"
            >
              Masz ograniczony dostęp do internetu
            </Heading>
            <Separator size="xs" tone="invisible" />
            <BlockText
              align={{
                "@onlyMobile": "center",
              }}
              font="ttfirs"
              size={{
                "@onlyMobile": "m",
                "@fromTablet": "xl",
                "@fromDesktop": "keyS",
              }}
              tone="secondary"
            >
              Co zrobić, żeby odblokować internet?
              <Separator size="none" tone="invisible" />
              Zaloguj się do swojego konta nju
              <Separator size="none" tone="invisible" />
              światłowód i zapłać za usługę.
            </BlockText>
            <Separator size="xxs" tone="invisible" />
            <div className="pt-4 max-w-[200px] only-mobile:mx-auto from-tablet:pt-5">
              <Link href={portalRoutes.zaloguj.index.get()} passHref={true}>
                <A
                  size={{
                    "@onlyMobile": "s",
                    "@fromTablet": "m",
                  }}
                >
                  <Text size="l">zaloguj się</Text>
                </A>
              </Link>
            </div>
          </div>
          <div className="overflow-hidden">
            <img
              alt="marketing"
              className="w-full object-contain"
              src="/images/marketing.svg"
            />
          </div>
        </div>
      </BlockContent>
    </div>
  );
}
